import PropTypes from "prop-types"
import React from "react"

import TextCollapsible from "src/components/TextCollapsible"

const RequestDescriptionSection = ({ requestDescription }) => {
  return (
    <div>
      <h2 className="mb-3 mt-0 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Request Description
      </h2>
      <TextCollapsible lines={3}>
        <span>{requestDescription}</span>
      </TextCollapsible>
    </div>
  )
}

RequestDescriptionSection.propTypes = {
  requestDescription: PropTypes.string,
}

export default RequestDescriptionSection
